import { render } from "./MultiStepForm.vue?vue&type=template&id=60787331&scoped=true"
import script from "./MultiStepForm.vue?vue&type=script&lang=js"
export * from "./MultiStepForm.vue?vue&type=script&lang=js"

import "./MultiStepForm.vue?vue&type=style&index=0&id=60787331&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60787331"]])

export default __exports__